import { Component, OnInit , ViewEncapsulation} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ComboItem } from 'app/models/combo-item';
import { ConfigDataService } from 'app/services/config-data.service';
import { PersonalService } from 'app/services/personal.service';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MyValidations } from '../../../utils/my-validations';
import { ErroresService } from '../../../core/services/errores.service';
import { GruposLiquidacionService } from 'app/services/gruposLiquidacion.service';
import { SociedadService } from 'app/services/sociedad.service';
import { SubSedeService } from '../../../services/subSede.service';
import { SubGrupoService } from '../../../services/subGrupo.service';
import { UnidadesOrganizativaService } from '../../../services/unidadesOrganizativa.service';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { ConfirmImportComponent } from '../../../components/shared/confirm-import/confirm-import.component';
import { DialogConfirmacionComponent } from '../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../components/shared/dialog-procesando/dialog-procesando.component';
import * as moment from 'moment';
import { MomentSetService } from '../../../core/services/moment-set.service';


@Component({
  selector: 'app-alta-personal',
  templateUrl: './alta-personal.component.html',
  styleUrls: ['./alta-personal.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true }
    }
  ]
})
export class AltaPersonalComponent implements OnInit {
  tituloTabla: string = "Personal";
  isLinear = false;
  rowsExport: any[] = [];
  empleadosImport: any[] = [];
  MensajeError: string = '';
  personalInvalido: boolean = false;
  
  edadMayoria: number = 18;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  altaInvalida: boolean;
  submitted = false;
  saleform1 = false;
  saleform2 = false;
  saleform3 = false;
  disabledEditing = false;
  personal: any;

  // Personal
  personalList: any;
  tratamientosList: any;
  idiomasList: any;
  sexosList: any;
  paisesList: any;
  estadoCivilList: any;
  titulosList: any;
  selectedTratamiento:ComboItem;
  SelectedIdioma:ComboItem;
  selectedSexo:ComboItem;
  selectedPais:ComboItem;
  selectedEC:ComboItem;
  selectedTitulo:ComboItem;
  selectedLegajo: string;

  // Personal Relacion
  sociedadesList: any;
  selectedSociedad:ComboItem;

  // Datos Organizativos
  sedesList: any;  
  SubSedesList: any;
  PosicionesList: any;
  UnidadesOrganizativasList: any;
  GruposLiquidacionList: any;
  GruposList: any;
  SubGruposList: any;
  grupoLiq: any;
  SubSedesListImpo: any;
  UnidadesOrganizativasListImpo: any;
  SubGruposListImpo: any;
  GruposLiquidacionListImpo: any;

  selectedSede:ComboItem;
  selectedSubSede:ComboItem;
  selectedPosicion:ComboItem;
  selectedUO:ComboItem;
  selectedGL:ComboItem;
  selectedGrupo:ComboItem;
  selectedSubGrupo:ComboItem;

  grupoActual:boolean =false;
  grupoRetroactividad:boolean=false;
  
  constructor(private personalSrv: PersonalService, 
              private translate: TranslateService,
              private config: PrimeNGConfig,
              private configDataSrv: ConfigDataService,
              private formBuilder: FormBuilder,
              private snackBar: MatSnackBar,
              private dialog: MatDialog,
              private erroresService: ErroresService,
              private router: Router,
              private subSedeSrv: SubSedeService,
              private subGupoSrv: SubGrupoService,
              private unidadesOSrv: UnidadesOrganizativaService,
              private gruposLiquidacionService: GruposLiquidacionService,
              private sociedadesService: SociedadService,
              private momentService: MomentSetService) { 
    this.personal = { id: 0, 
                      legajo: '', 
                      IDFiscal: '', 
                      fecNacimiento:'', 
                      nombre: '',
                      apellido: '', 
                      segundoApellido: '', 
                      email:'',  
                      celular: '' };
  }

  ngOnInit(): void {   
    this.buildFrom();
    this.translate.get('primeng').subscribe(res => {this.config.setTranslation(res);});
    this.configDataSrv.getDatosPersonales().subscribe(
      data => {
        this.tratamientosList=data["Tratamientos"];
        this.idiomasList=data["Idiomas"];
        this.sexosList=data["Sexos"];
        this.paisesList=data["Paises"];
        this.estadoCivilList=data["EstadoCivil"];
        this.titulosList=data["Titulos"];     
      },
      error => {
        console.log(error);
      }
    );

    this.configDataSrv.GetCombosInfoDatosOrganizativos().subscribe(
      data => {
        this.sedesList=data["Sedes"];
        this.PosicionesList=data["Posiciones"];
        this.GruposLiquidacionList=data["GruposLiquidacion"];
        this.GruposList=data["Grupos"];
      },
      error => {
        console.log(error);
      }
    );

    this.sociedadesService.getAll().subscribe(data =>{this.sociedadesList = data});
    this.personalSrv.getAll().subscribe(data =>{this.personalList = data});
    this.subGupoSrv.getAll().subscribe(data => { this.SubGruposListImpo = data });
    this.unidadesOSrv.getAll().subscribe(data => { this.UnidadesOrganizativasListImpo = data })
    this.subSedeSrv.getAll().subscribe(data => { this.SubSedesListImpo = data })
    this.gruposLiquidacionService.getAll().subscribe(
      data => 
    { 
      data.forEach((currentValue,index,arr) => {
        if (currentValue.periodoRetroactividadNavigation != null)
        {
          currentValue.periodoRetroactividadNavigation.fechaDd = this.momentService.convertDateServer(currentValue.periodoRetroactividadNavigation.fechaDd);
          currentValue.periodoRetroactividadNavigation.fechaHh = this.momentService.convertDateServer(currentValue.periodoRetroactividadNavigation.fechaHh);
          currentValue.periodoRetroactividadNavigation.fechaPago = this.momentService.convertDateServer(currentValue.periodoRetroactividadNavigation.fechaPago);
        }
        if (currentValue.periodoActualNavigation != null)
        {
          currentValue.periodoActualNavigation.fechaDd = this.momentService.convertDateServer(currentValue.periodoActualNavigation.fechaDd);
          currentValue.periodoActualNavigation.fechaHh = this.momentService.convertDateServer(currentValue.periodoActualNavigation.fechaHh);
          currentValue.periodoActualNavigation.fechaPago = this.momentService.convertDateServer(currentValue.periodoActualNavigation.fechaPago);
        }        
      });

      this.GruposLiquidacionListImpo = data;
    })

    this.newEmployee();
    
  }

  get f1() { return this.firstFormGroup.controls; }
  get f2() { return this.secondFormGroup.controls; }
  get f3() { return this.thirdFormGroup.controls; }

  compareFn(a, b) {
    return a && b && a.id == b.id;
  }

  guardar(): void
  {
    if (this.validarDatos())
    {
      this.submitted = true;
      if(this.firstFormGroup.valid && this.secondFormGroup.valid && this.thirdFormGroup.valid){
        
        let datos = {
          id: this.thirdFormGroup.value.id,
          legajo: this.thirdFormGroup.value.legajo,
          IDfiscal: this.thirdFormGroup.value.IDfiscal,
          fecNacimiento: this.momentService.saveDateServer(this.thirdFormGroup.value.fecNacimiento, false),
          nombre: this.thirdFormGroup.value.nombre,
          apellido: this.thirdFormGroup.value.apellido,
          segundoApellido: this.thirdFormGroup.value.segundoApellido,
          nacionalidad: this.thirdFormGroup.value.nacionalidad,
          idioma: this.thirdFormGroup.value.idioma,
          estadoCivil: this.thirdFormGroup.value.estadoCivil,
          tratamiento: this.thirdFormGroup.value.tratamiento,
          sexo: this.thirdFormGroup.value.sexo,
          email: this.thirdFormGroup.value.email,
          celular: this.thirdFormGroup.value.celular,
          desde: this.momentService.saveDateServer(this.firstFormGroup.value.desde, false),
          hasta: this.momentService.saveDateServer(this.firstFormGroup.value.hasta, false),
          sociedad: this.firstFormGroup.value.sociedad,
          sede: this.firstFormGroup.value.sede,
          subSede: this.firstFormGroup.value.subSede,
          posicion: this.firstFormGroup.value.posicion,
          unidadOrganizativa: this.firstFormGroup.value.unidadOrganizativa,
          grupoLiquidacion: this.secondFormGroup.value.grupoLiquidacion,
          grupoPersonal: this.secondFormGroup.value.grupoPersonal,
          subGrupo: this.secondFormGroup.value.subGrupo  
        };

        this.personalSrv.SavePersonal(datos).subscribe(
          data => {
              this.router.navigate(['gestionar', {legajo: this.thirdFormGroup.value['legajo']}]);
          },
        error => {
            console.log(error);
            
            if (error.status == 400)
            {
              this.altaInvalida = true;
              
              this.MensajeError = this.erroresService.MostrarError400(error);
            }
            else
            {
              this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
            }

          },
          () => {
            //this.router.navigate(['gestionar', {id: this.personalForm.value['legajo']}]);
            // 'onCompleted' callback.
            // No errors, route to new page here
          }
          );        
          
      }
    }
  }

  newEmployee(){
    this.personalSrv.newEmployee()
    .subscribe(
      data => {
        this.personal=data;
        this.selectedLegajo = this.personal.legajo;
        this.buildFrom();
        
        let wexport = { legajo: data.legajo,
          IDFiscal: data.IDfiscal, 
          fecNacimiento: data.fecNacimiento,
          nombre: data.nombre,
          apellido: data.apellido,
          segundoApellido: data.segundoApellido,
          email: data.email,
          celular: data.celular,
          nacionalidad: '',
          idioma: '',
          estadoCivil: '',
          tratamiento: '',
          sexo: '',
          desde: '',
          hasta: '',
          sociedad: '',
          sede: '',
          subSede: '',
          posicion: '',
          unidadOrganizativa: '',
          grupoLiquidacion: '',
          grupoPersonal: '',
          subGrupo: ''};
        
        this.rowsExport.push(wexport);
      },
      error => {
        console.log(error);
      });
  }

  buildFrom(){
    this.firstFormGroup = this.formBuilder.group({
      desde: [new Date(), Validators.required],
      hasta: [new Date("2999-12-31T23:59:59"), [Validators.required, MyValidations.fecHastaMenor]],
      sociedad: [this.selectedSociedad, Validators.required],
      sede: [this.selectedSede, Validators.required],
      subSede: [this.selectedSubSede, Validators.required],
      posicion: [this.selectedPosicion, Validators.required],
      unidadOrganizativa: [this.selectedUO, Validators.required]
    });
    this.secondFormGroup = this.formBuilder.group({
      grupoLiquidacion: [this.selectedGL, Validators.required],
      grupoPersonal: [this.selectedGrupo, Validators.required],
      subGrupo: [this.selectedSubGrupo, Validators.required]    
    });
    this.thirdFormGroup = this.formBuilder.group({
      id: [this.personal.id],
      legajo: [this.personal.legajo, [Validators.required, Validators.pattern(/^[+]*[0-9]{1,8}[0-9]*$/)]],
      IDfiscal: [this.personal.idfiscal, Validators.required],
      fecNacimiento: [null,[Validators.required, MyValidations.isYounger(this.edadMayoria)]],
      nombre: [this.personal.nombre, [Validators.required, Validators.pattern(/^[\p{L}\s]+$/u)]],
      apellido: [this.personal.apellido, [Validators.required, Validators.pattern(/^[\p{L}\s]+$/u)]],
      segundoApellido: [this.personal.segundoApellido, Validators.pattern(/^[\p{L}\s]+$/u)],
      nacionalidad: [this.selectedPais, Validators.required],
      idioma: [this.SelectedIdioma, Validators.required],
      estadoCivil: [this.selectedEC, Validators.required],
      tratamiento: [this.selectedTratamiento, Validators.required],
      sexo: [this.selectedSexo, Validators.required],
      email: [this.personal.email, [Validators.required, Validators.email]],
      celular: [this.personal.telefono,  [Validators.required, Validators.pattern(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/)]]
    });
  }

  cargarSubSedes(sede:number){
    if (sede != null) {
      this.subSedeSrv.getSubSedes(sede).subscribe(subSede => { this.SubSedesList = subSede })
    }
  }

  cargarSubGrupos(grupo:number){
    if (grupo != null) {
      this.subGupoSrv.getSubGrupos(grupo).subscribe(subGrupo => { this.SubGruposList = subGrupo })
    }
  }

  cargarUnidadesOrganizativas(sociedad:number){
    if (sociedad != null) {
      this.unidadesOSrv.getBySociedad(sociedad).subscribe(unidad => { this.UnidadesOrganizativasList = unidad })
    }
  }
  
  onChangeSede(event) {
    this.firstFormGroup.controls['subSede'].setValue(null);
    this.cargarSubSedes(event.value);    
  }

  onChangeGrupo(event) {
    this.secondFormGroup.controls['subGrupo'].setValue(null);
    this.cargarSubGrupos(event.value);    
  }

  onChangeSociedad(event) {
    this.firstFormGroup.controls['unidadOrganizativa'].setValue(null);
    this.cargarUnidadesOrganizativas(event.value);
    //busco la mayoria de edad de la sociedad
    this.edadMayoria = 18;
    let sociedad = this.sociedadesList.find(d => d.id == event.value);
    if (sociedad.mayoriaEdad != null) this.edadMayoria = sociedad.mayoriaEdad;
    this.setValidatorEdad();
  }

  setValidatorEdad() {
    this.thirdFormGroup.controls["fecNacimiento"].setValidators([Validators.required, MyValidations.isYounger(this.edadMayoria)]);
    this.thirdFormGroup.controls["fecNacimiento"].updateValueAndValidity();
  }

  validarDatos() : boolean
  {
    let desde = this.firstFormGroup.get("desde").value.toDateString();
    let grupo = this.secondFormGroup.get("grupoLiquidacion").value;
    this.grupoLiq = this.GruposLiquidacionListImpo.find(d => d.id == grupo);
    
    this.grupoActual = false;
    this.grupoRetroactividad = false;
    
    if (this.grupoLiq.periodoActual == undefined || this.grupoLiq.periodoActual == 0) 
    {
      this.grupoActual = true;
      this.secondFormGroup.get("grupoLiquidacion").setErrors({ 'invalid': true });
    } 
    else if (this.grupoLiq.periodoRetroactividad == undefined || this.grupoLiq.periodoRetroactividad == 0) 
    {
      this.grupoRetroactividad = true;
      this.secondFormGroup.get("grupoLiquidacion").setErrors({ 'invalid': true });
    } 
    else
    {
      let fretro = new Date(this.grupoLiq.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        this.firstFormGroup.get("desde").setErrors({'anteriorRetroactividad': true });
      }
    }
    
    if (this.firstFormGroup.valid && this.secondFormGroup.valid)
    {
      return true;
    }
    else
    {
      this.firstFormGroup.markAllAsTouched();
      return false;
    }
  }

  sale1(){
    this.saleform1 = true;
  }
  sale2(){
    this.saleform2 = true;
  }
  sale3(){
    this.saleform3 = true;
  }

  import(rowsImport){
    this.empleadosImport = [];
    var count = 0;
    let habilita = true;

    rowsImport.forEach((currentValue,index,arr) => {
      let errores = this.validacionesimport(currentValue);
      if (errores.length > 0) habilita = false;
      count++;

      let winsert = { id: 0,
        legajo: currentValue.legajo,
        IDFiscal: currentValue.IDFiscal, 
        fecNacimiento: currentValue.fecNacimiento,
        nombre: currentValue.nombre,
        apellido: currentValue.apellido,
        segundoApellido: currentValue.segundoApellido,
        email: currentValue.email,
        celular: currentValue.celular,
        nacionalidad: currentValue.nacionalidad,
        idioma: currentValue.idioma,
        estadoCivil: currentValue.estadoCivil,
        tratamiento: currentValue.tratamiento,
        sexo: currentValue.sexo,
        desde: currentValue.desde,
        hasta: currentValue.hasta,
        sociedad: currentValue.sociedad,
        sede: currentValue.sede,
        subSede: currentValue.subSede,
        posicion: currentValue.posicion,
        unidadOrganizativa: currentValue.unidadOrganizativa,
        grupoLiquidacion: currentValue.grupoLiquidacion,
        grupoPersonal: currentValue.grupoPersonal,
        subGrupo: currentValue.subGrupo,
        errores: errores};

      this.empleadosImport.push(winsert);      
    });

    //Abrir venatana con detalle y boton de confirmacion
    let dialogRef = this.dialog.open(ConfirmImportComponent, {
      width: '1000px',
      data: { registros: this.empleadosImport, 
              confirmButtonEnabled: habilita },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result =>
    {
      if (result == 'confirmado')
      {
        //Debo guardar los regitros
        this.confirmaImport(this.empleadosImport);        
      }
    });
  }  

  validacionesimport(empleado) : string[]
  {    
    const errores = [];
    let index, index2;

    //Datos Personales
    index = this.personalList.findIndex(x => x.code == empleado.legajo);
    index2 = this.empleadosImport.findIndex(x => x.legajo == empleado.legajo);
    if (index != -1 || index2 != -1)
    {
      errores.push('Ya existe un empleado con el mismo Legajo' );
    } 
    if (!empleado.legajo || empleado.legajo == undefined || isNaN(empleado.legajo)) 
    {
      errores.push('El campo "Legajo" es obligatorio ingresar un número');
    }
    index = this.personalList.findIndex(x => x.fiscalId == empleado.IDFiscal);
    if (index != -1) 
    {
      errores.push('Ya existe un empleado con el mismo ID Fiscal' );
    }
    if (!empleado.IDFiscal || empleado.IDFiscal == undefined) 
    {
      errores.push('El campo "IDFiscal" es obligatorio');
    }
    if (!empleado.nombre || empleado.nombre == undefined) 
    {
      errores.push('El campo "nombre" es obligatorio');
    }
    if (!empleado.apellido || empleado.apellido == undefined) 
    {
      errores.push('El campo "apellido" es obligatorio');
    }
    if (!empleado.email || empleado.email == undefined) 
    {
      errores.push('El campo "email" es obligatorio');
    }
    if (!empleado.celular || empleado.celular == undefined || isNaN(empleado.celular)) 
    {
      errores.push('El campo "celular" es obligatorio ingresar un número');
    }
    if (!empleado.fecNacimiento || empleado.fecNacimiento == undefined || isNaN(Date.parse(empleado.fecNacimiento))) 
    {
      errores.push('El campo "fecNacimiento" es obligatorio ingresar una fecha');
    }
    index = this.paisesList.findIndex(i => i.codigo == empleado.nacionalidad);
    if (index == -1 )
    {
      errores.push('El campo "nacionalidad" no se corresponde a un País válido' );
    }
    index = this.idiomasList.findIndex(i => i.codigo == empleado.idioma);
    if (index == -1 )
    {
      errores.push('El campo "idioma" no se corresponde a un Idioma válido' );
    }
    index = this.estadoCivilList.findIndex(i => i.codigo == empleado.estadoCivil);
    if (index == -1 )
    {
      errores.push('El campo "estadoCivil" no se corresponde a un Estado Civil válido' );
    }
    index = this.tratamientosList.findIndex(i => i.descripcion == empleado.tratamiento);
    if (index == -1 )
    {
      errores.push('El campo "tratamiento" no se corresponde a un Tratamiento válido' );
    }
    index = this.sexosList.findIndex(i => i.codigo == empleado.sexo);
    if (index == -1 )
    {
      errores.push('El campo "sexo" no se corresponde a un Sexo válido' );
    }

    //Datos Organizacion
    if (!empleado.desde || empleado.desde == undefined || isNaN(Date.parse(empleado.desde))) 
    {
      errores.push('El campo "desde" es obligatorio ingresar una fecha' );
    }
    if (!empleado.hasta || empleado.hasta == undefined || isNaN(Date.parse(empleado.hasta))) 
    {
      errores.push('El campo "hasta" es obligatorio ingresar una fecha' );
    }
    if (Date.parse(empleado.desde) > Date.parse(empleado.hasta)) 
    {
      errores.push('El campo  "hasta" es anterior al campo "desde"' );
    }
    let sociedad;
    index = this.sociedadesList.findIndex(i => i.codigo == empleado.sociedad);
    if (index == -1 )
    {
      errores.push('El campo "sociedad" no se corresponde a una Sociedad válida' );
    } else 
    {
      sociedad = this.sociedadesList[index];
    }    
    index = this.UnidadesOrganizativasListImpo.findIndex(i => i.codigo == empleado.unidadOrganizativa);
    if (index == -1 )
    {
      errores.push('El campo "unidadOrganizativa" no se corresponde a una Unidad Organizativa válida' );
    } else if (sociedad != undefined)
    {
      if (this.UnidadesOrganizativasListImpo[index].sociedad != sociedad.id )
      {
        errores.push('El campo "unidadOrganizativa" no pertenece a la Sociedad' );
      }
    }
    let sede;
    index = this.sedesList.findIndex(i => i.codigo == empleado.sede);
    if (index == -1 ){
      errores.push('El campo "sede" no se corresponde a una Sede válida' );
    } else
    {
      sede = this.sedesList[index];
    }    
    index = this.SubSedesListImpo.findIndex(i => i.codigo == empleado.subSede);
    if (index == -1 )
    {
      errores.push('El campo "subSede" no se corresponde a una Subsede válida' );
    } else if (sede != undefined) 
    {
      if (this.SubSedesListImpo[index].sede != sede.id )
      {
        errores.push('El campo "subSede" no pertenece a la Sede' );
      }
    }
    index = this.PosicionesList.findIndex(i => i.codigo == empleado.posicion);
    if (index == -1 )
    {
      errores.push('El campo "posicion" no se corresponde a una Posición válida' );
    }
    //busco la mayoria de edad de la sociedad
    let edadMayoria = 18;
    if (sociedad != undefined)
    {
      if (sociedad.mayoriaEdad != null) edadMayoria = sociedad.mayoriaEdad;
    }    
    const age = moment().diff(empleado.fecNacimiento, 'years');
    if (age < edadMayoria) 
    {
      errores.push('El empleado no puede ser menor de ' + edadMayoria.toString() + ' años' );
    }

    //Datos Liquidacion
    let grupoLiqui;
    index = this.GruposLiquidacionListImpo.findIndex(i => i.codigo == empleado.grupoLiquidacion);
    if (index == -1 )
    {
      errores.push('El campo "grupoLiquidacion" no se corresponde a un Grupo de Liquidación válido' );
    } else
    {
      grupoLiqui = this.GruposLiquidacionListImpo[index];
      if (grupoLiqui.periodoActual == undefined || grupoLiqui.periodoActual == 0) 
      {
        errores.push('El Grupo Liquidación no tiene definido un Período Actual' );
      } else if (grupoLiqui.periodoRetroactividad == undefined || grupoLiqui.periodoRetroactividad == 0) 
      {
        errores.push('El Grupo Liquidación no tiene definido un Período Retroactividad' );
      } else
      {
        let fretro = new Date(grupoLiqui.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(empleado.desde) < Date.parse(fretro) )
        {
          errores.push('La fecha desde no puede ser anterior al límite de retroactividad ' + fretro );
        }
      }
    }
    let grupo;    
    index = this.GruposList.findIndex(i => i.codigo == empleado.grupoPersonal);
    if (index == -1 )
    {
      errores.push('El campo "grupoPersonal" no se corresponde a un Grupo de Personal válido' );
    } else
    {
      grupo = this.GruposList[index];
    }    
    index = this.SubGruposListImpo.findIndex(i => i.codigo == empleado.subGrupo);
    if (index == -1 )
    {
      errores.push('El campo "subGrupo" no se corresponde a un Subgrupo de Personal válido' );
    } else if (grupo != undefined)
    {
      if (this.SubGruposListImpo[index].grupo != grupo.id )
      {
        errores.push('El campo "subGrupo" no pertenece al Grupo de Personal' );
      }
    }
    
    return errores;
  }

  confirmaImport(rowsImport){
    var count = 0;

    rowsImport.forEach((currentValue,index,arr) => {
      count++;
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      //busco los Ids
      let nacionalidadID = 0;
      let idiomaID = 0;
      let estadoCivilID = 0;
      let tratamientoID = 0;
      let sexoID = 0;
      let sociedadID = 0;
      let sedeID = 0;
      let subSedeID = 0;
      let posicionID = 0;
      let unidadOrganizativaID = 0;
      let grupoLiquidacionID = 0;
      let grupoPersonalID = 0;
      let subGrupoID = 0;
      index = this.paisesList.findIndex(i => i.codigo == currentValue.nacionalidad);
      if (index != -1 ) nacionalidadID = this.paisesList[index].id;
      index = this.idiomasList.findIndex(i => i.codigo == currentValue.idioma);
      if (index != -1 ) idiomaID = this.idiomasList[index].id;
      index = this.estadoCivilList.findIndex(i => i.codigo == currentValue.estadoCivil);
      if (index != -1 ) estadoCivilID = this.estadoCivilList[index].id;
      index = this.tratamientosList.findIndex(i => i.descripcion == currentValue.tratamiento);
      if (index != -1 ) tratamientoID = this.tratamientosList[index].id;
      index = this.sexosList.findIndex(i => i.codigo == currentValue.sexo);
      if (index != -1 ) sexoID = this.sexosList[index].id;
      index = this.sociedadesList.findIndex(i => i.codigo == currentValue.sociedad);
      if (index != -1 ) sociedadID = this.sociedadesList[index].id;
      index = this.sedesList.findIndex(i => i.codigo == currentValue.sede);
      if (index != -1 ) sedeID = this.sedesList[index].id;
      index = this.SubSedesListImpo.findIndex(i => i.codigo == currentValue.subSede);
      if (index != -1 ) subSedeID = this.SubSedesListImpo[index].id;
      index = this.PosicionesList.findIndex(i => i.codigo == currentValue.posicion);
      if (index != -1 ) posicionID = this.PosicionesList[index].id;
      index = this.UnidadesOrganizativasListImpo.findIndex(i => i.codigo == currentValue.unidadOrganizativa);
      if (index != -1 ) unidadOrganizativaID = this.UnidadesOrganizativasListImpo[index].id;
      index = this.GruposLiquidacionListImpo.findIndex(i => i.codigo == currentValue.grupoLiquidacion);
      if (index != -1 ) grupoLiquidacionID = this.GruposLiquidacionListImpo[index].id;
      index = this.GruposList.findIndex(i => i.codigo == currentValue.grupoPersonal);
      if (index != -1 ) grupoPersonalID = this.GruposList[index].id;
      index = this.SubGruposListImpo.findIndex(i => i.codigo == currentValue.subGrupo);
      if (index != -1 ) subGrupoID = this.SubGruposListImpo[index].id;
      let segundoApellido = '';
      if (currentValue.segundoApellido != undefined) segundoApellido = currentValue.segundoApellido;

      let winsert = { id: 0,
        legajo: currentValue.legajo,
        IDFiscal: currentValue.IDFiscal, 
        fecNacimiento: currentValue.fecNacimiento,
        nombre: currentValue.nombre,
        apellido: currentValue.apellido,
        segundoApellido: currentValue.segundoApellido,
        email: currentValue.email,
        celular: currentValue.celular,
        nacionalidad: nacionalidadID,
        idioma: idiomaID,
        estadoCivil: estadoCivilID,
        tratamiento: tratamientoID,
        sexo: sexoID,
        desde: currentValue.desde,
        hasta: currentValue.hasta,
        sociedad: sociedadID,
        sede: sedeID,
        subSede: subSedeID,
        posicion: posicionID,
        unidadOrganizativa: unidadOrganizativaID,
        grupoLiquidacion: grupoLiquidacionID,
        grupoPersonal: grupoPersonalID,
        subGrupo: subGrupoID};

      this.personalSrv.SavePersonal(winsert).subscribe(
        empleado =>
        {
          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
              this.MensajeError = error.error;
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    });
    this.snackBar.open('Se procesaron ' + count + ' registros nuevos.' , "OK", { duration: 10000 });
  }
}
